import React from "react";
import { Link } from "react-router-dom";
import TimelineItem from "../components/TimelineItem";
import { timelineData } from "../data/timelineData";

const VerticalTimeline = () => {
  return (
    <div className="min-h-screen w-full bg-[#1E1E1E] overflow-x-hidden">
      {/* Back to Home Link */}
      <Link
        to="/"
        className="text-[#FFCD29] text-2xl sm:text-2xl md:text-2xl lg:text-3xl absolute top-6 left-6 sm:top-10 sm:left-6 md:top-12  md:left-8 font-semibold hover:scale-105 transition-transform duration-200"
      >
        home
      </Link>

      {/* Page Header */}
      <div className="pt-24 sm:pt-20 md:pt-32 pb-8 sm:pb-12 md:pb-20 px-2 sm:px-6 lg:px-8">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white  text-center">
          this is my{" "}
          <span className="font-semibold  text-[#FFCD29]">
            featured timeline
          </span>
        </h1>
        <p className="text-center text-gray-400 mt-4 text-sm sm:text-base md:text-lg max-w-3xl mx-auto px-6">
          A journey through my professional milestones and achievements
        </p>
      </div>

      {/* Timeline Container */}
      <div className="flex justify-center px-8 sm:px-6 lg:px-8 pb-16 sm:pb-20">
        <div className="w-full max-w-4xl md:max-w-4xl lg:max-w-5xl xl:max-w-6xl">
          <ol className="relative border-s-2 border-yellow-400 pl-4 sm:pl-6 md:pl-8">
            {timelineData.map((event, index) => (
              <TimelineItem key={index} event={event} index={index} />
            ))}
          </ol>
        </div>
      </div>
    </div>
  );
};

export default VerticalTimeline;
